<script setup>
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import { Float } from '@headlessui-float/vue';
import { router } from '@inertiajs/vue3';
import { onUnmounted, ref } from 'vue';

const key = ref(0);

onUnmounted(
    router.on('start', () => key.value++),
);
</script>

<template>
    <Menu :key="key">
        <Float
            portal
            placement="bottom-start"
            :offset="4"
            :shift="8"
            :flip="10"
            enter="transition ease-out duration-100"
            enter-from="transform opacity-0 scale-95"
            enter-to="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leave-from="transform opacity-100 scale-100"
            leave-to="transform opacity-0 scale-95"
        >
            <MenuButton
                v-slot="{ open }"
                as="template"
            >
                <slot
                    name="trigger"
                    :open="open"
                />
            </MenuButton>

            <MenuItems
                class="z-40 rounded-md border border-gray-300 bg-white shadow-lg focus:outline-hidden sm:min-w-44"
            >
                <div class="divide-y divide-gray-100">
                    <slot name="content" />
                </div>
            </MenuItems>
        </Float>
    </Menu>
</template>
